import { createContext } from 'react';

import type { DndContextStore } from '../../shared/entities/dnd-context.store';

export const DndContext = createContext<DndContextStore<any, any, any, any, any>>(null!);
